// src/pages/Profile.js
import React, { useState, useEffect } from 'react';
import { Typography, Box } from '@mui/material';

function Profile() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (window.Pi) {
      const scopes = ['username', 'payments'];
      window.Pi.authenticate(scopes, (payment) => {
        console.log("Incomplete payment found:", payment);
      })
        .then((auth) => {
          setUser(auth.user);
          setLoading(false);
        })
        .catch((error) => {
          console.error("Authentication error:", error);
          setLoading(false);
        });
    } else {
      console.error("Pi SDK not found.");
      setLoading(false);
    }
  }, []);

  return (
    <Box textAlign="center">
      <Typography variant="h4" gutterBottom>
        Profile
      </Typography>
      {loading ? (
        <Typography>Loading profile...</Typography>
      ) : user ? (
        <Box>
          <Typography variant="body1">Username: {user.username}</Typography>
          <Typography variant="body2">User ID: {user.uid}</Typography>
        </Box>
      ) : (
        <Typography>Error loading profile.</Typography>
      )}
    </Box>
  );
}

export default Profile;
